export default {

  // Contact = Somebody I trust

  create({ contactUserId }, data) {
    return {
      contactUserId: contactUserId, // stored in key

      // createdAt: ??? (when did we become friends)

      // accessLevel: ??

      sharedGoalId: null,
      sharedIncommingCommitmentId: null,
      // sharedOutgoingCommitment: null, // this is not need, it is the outgoingComitment of the other user (+1 query?)

      // Darf mich dieser user stören?
      // TODO: Should this information be protected towards the other user?
      //       (The other user should not know that I'm blocking him)
      allowInterrupt: true,

      // Dürfen mir Tasks gedroped werden
      allowDropTasks: true,

      numNewMessages: 0,

      // sharedProjects: []    // TODO
    };
  },

  fields: {
    contactUserId: { validate_bolt_type: 'UserID' },
    sharedGoalId: { validate_bolt_type: 'AnyID' },
    sharedIncommingCommitmentId: { validate_bolt_type: 'AnyID' },
    // sharedOutgoingCommitment: { validate_bolt_type: 'AnyID' },
    allowInterrupt: { validate_bolt_type: 'Boolean' },
    allowDropTasks: { validate_bolt_type: 'Boolean' },
    numNewMessages: { validate_bolt_type: 'Number' },
  }
};
